import * as React from "react";
import { QueryString } from "@grandvisionhq/utils";
import ErrorBoundary from "../../../../../../../../../components/ErrorBoundary/v3/components/ErrorBoundary/ErrorBoundary.js";
import useClientSideRouter from "../../../../../../../../../hooks/v3/hooks/use-client-side-router.js";
import { RoutingError } from "../../../../../../../v3/pages/CancelAppointment/errors.js";
import { CancelAppointmentProvider } from "../../../../../../v3/pages/CancelAppointment/context/provider.js";
import { RoutingContext } from "./context.js";
const RoutingContextProvider = ({
  routeMap,
  initialRoutingState,
  initialState,
  children
}) => {
  const { Provider } = RoutingContext;
  const {
    basePath,
    currentRoute: initialRoute,
    queryParams: initialQueryParams
  } = initialRoutingState;
  const [{ goTo }, { queryParams, currentRoute }] = useClientSideRouter({
    basePath,
    initialRoute,
    initialQueryParams
  });
  const goToHandler = React.useCallback(
    (route, queryParams2) => {
      const newQueryParams = { ...queryParams2 };
      Object.keys(newQueryParams).forEach(
        (key) => newQueryParams[key] === void 0 ? delete newQueryParams[key] : {}
      );
      goTo(`${basePath}/${route}${QueryString.stringify(newQueryParams)}`);
    },
    [basePath, goTo]
  );
  const value = React.useMemo(
    () => [
      { goTo: goToHandler },
      {
        component: routeMap[currentRoute],
        queryParams,
        currentRoute,
        basePath
      }
    ],
    [routeMap, goToHandler, currentRoute, basePath, queryParams]
  );
  const Component = routeMap[currentRoute];
  return /* @__PURE__ */ React.createElement(Provider, { value }, /* @__PURE__ */ React.createElement(CancelAppointmentProvider, { ...initialState }, /* @__PURE__ */ React.createElement(ErrorBoundary, { bookAppointmentUrl: initialState.bookAppointmentUrl }, /* @__PURE__ */ React.createElement(Component, null))), children);
};
RoutingContextProvider.getServerSideProps = (currentRoute, routeMap) => {
  const isValidRoute = currentRoute in routeMap;
  if (!isValidRoute) {
    throw new Error(RoutingError.INVALID_ROUTE);
  }
  if (currentRoute === "confirmation") {
    throw new Error(RoutingError.SERVER_SIDE_CONFIRMATION_ATTEMPT);
  }
};
export {
  RoutingContextProvider
};
//# sourceMappingURL=provider.js.map
